import React from 'react';
import styled from 'styled-components';
import { ConfirmModal } from '../ConfirmModal';
import { DialogBox } from '../Dialog';
import defaults from '../translations/en.json';
const AcknowledgeText = styled.div.withConfig({
  displayName: "EmailAcknowledgeModal__AcknowledgeText",
  componentId: "sc-1woa89v-0"
})(["text-align:left;& > p{margin:0 0 10px;text-indent:2em;}"]);
const Caution = styled.div.withConfig({
  displayName: "EmailAcknowledgeModal__Caution",
  componentId: "sc-1woa89v-1"
})(["color:#d32f2f;font-size:1.5rem;font-weight:700;line-height:1.2;margin:0 0 16px;text-align:center;"]);
export const EmailAcknowledgeModal = ({
  open,
  onCancel,
  onContinue
}) => /*#__PURE__*/React.createElement(DialogBox, {
  open: open,
  disableBackdropClick: true,
  disableEscapeKeyDown: true,
  handleClick: onCancel,
  disableScrollLock: true,
  noIcon: true,
  fullWidth: true,
  maxWidth: "sm",
  title: defaults.emailAcknowledgeTitle
}, /*#__PURE__*/React.createElement(ConfirmModal, {
  onOKClick: onContinue,
  okText: defaults.emailAcknowledgeContinue,
  onCancelClick: onCancel,
  noText: defaults.cancel,
  modalText: "",
  style: {
    width: '100%'
  },
  content: /*#__PURE__*/React.createElement(AcknowledgeText, null, /*#__PURE__*/React.createElement(Caution, null, defaults.emailAcknowledgeCaution), /*#__PURE__*/React.createElement("p", null, defaults.emailAcknowledgeCertification), /*#__PURE__*/React.createElement("p", null, defaults.emailAcknowledgeRisk))
}));